import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../aws/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE_URL}/v1-compras`; 

export const useGetCompras = () => {
  const { getJwtToken } = useAuth();
  return useQuery({
    queryKey: ['compras'],
    queryFn: async () => {
      const token = await getJwtToken();
      const res = await fetch(API_URL, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error('Error al cargar historial de compras');
      return res.json();
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useSaveCompra = () => {
  const queryClient = useQueryClient();
  const { getJwtToken } = useAuth();
  
  return useMutation({
    mutationFn: async (payload) => {
      const token = await getJwtToken();
      const esEdicion = !!payload.id;
      const url = esEdicion ? `${API_BASE_URL}/v1-compras/${payload.id}` : `${API_BASE_URL}/v1-compras`;

      const res = await fetch(url, {
        method: esEdicion ? "PUT" : "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error('Error al guardar la compra');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['compras'] });
      queryClient.invalidateQueries({ queryKey: ['productos'] }); 
      queryClient.invalidateQueries({ queryKey: ['proveedores'] });
      queryClient.invalidateQueries({ queryKey: ['caja'] });
      queryClient.invalidateQueries({ queryKey: ['stock_bodega'] });
      queryClient.invalidateQueries({ queryKey: ['bodegas'] });
    }
  });
};

export const useDeleteCompra = () => {
  const queryClient = useQueryClient();
  const { getJwtToken } = useAuth();
  
  return useMutation({
    mutationFn: async (id) => {
      const token = await getJwtToken();
      const res = await fetch(`${API_BASE_URL}/v1-compras/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Error al eliminar la compra');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['compras'] });
      queryClient.invalidateQueries({ queryKey: ['productos'] }); 
      queryClient.invalidateQueries({ queryKey: ['proveedores'] });
      queryClient.invalidateQueries({ queryKey: ['caja'] });
    }
  });
};